import { useCurrentWorkspace } from '@/context/current-workspace';

/**
 * The workspace id for the integrations page.
 *
 * Not `requireWorkspaceId()`: that re-reads `window.location`, which lags the router location while
 * the `/workspaces/last` sentinel is being rewritten (CON-7180), so a tab rendered in that window
 * finds no id and throws to the error boundary. `useCurrentWorkspace` already solves this — it
 * derives from the reactive location for the same reason, and additionally resolves `last` from the
 * session instead of waiting for the URL rewrite.
 *
 * The route view holds a loader until the workspace resolves, so by the time anything under it
 * renders this has a value.
 */
export function useIntegrationsWorkspaceId(): number {
  const workspace = useCurrentWorkspace();
  if (workspace == null) {
    throw new Error('No current workspace for the integrations route.');
  }
  return workspace.id;
}
